export enum HeaderSections {
    Landing = "LANDING",
    MyGeotab = "MYGEOTAB",
    MyAdmin = "MYADMIN",
    Drive = "DRIVE",
    Hardware = "HARDWARE"
}
